import React, { useEffect } from 'react'

export default function Tickets() {
    useEffect(() => {
        window.location.href = 'https://eventbuzz.co.il/lp/event/fiesta'
    }, [])
    return (
        <div></div>
    )
}